import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";
import Header from "./components/Header/Header";

const Layout = () => {
  return (
    <>
      <Header />
      <Box
        sx={{
          // Mobile: Toolbar (64px) + search row (~48px) = 112px
          // Tablet/desktop: Toolbar only (64px)
          pt: { xs: '112px', md: '64px' },
          minHeight: '100vh',
        }}
      >
        <Outlet />
      </Box>
    </>
  );
};

export default Layout;
